// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/chevrons-up-down.js';

import { paths } from '../generated/chevrons-up-down';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('chevrons-up-down', Original, paths);
